import React from "react";
import PropTypes from "prop-types";

import StandardTextAndNumbers from "./StandardTextAndNumbers";
import ComponentMissing from "../../Debug/ComponentMissing";

const TextAndNumbersSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  cardHeader,
  numbers,
  mirrored,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    cardHeader,
    numbers,
    mirrored,
    animation,
  };

  function switchTextAndNumbers() {
    switch (layout) {
      case "standard":
        return <StandardTextAndNumbers properties={properties} />;
      default:
        return <ComponentMissing type="TextAndNumbers" subType={layout} />;
    }
  }

  return switchTextAndNumbers();
};

TextAndNumbersSwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  cardHeader: PropTypes.string,
  numbers: PropTypes.instanceOf(Array),
  mirrored: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  animation: PropTypes.instanceOf(Object),
};

export default TextAndNumbersSwitcher;
